import { AxiosResponse } from 'axios';
import { User } from 'oidc-client-ts';
import { ResourceGroupSuccesses } from 'ia-react-core/~/components/resource/ResourceGroup';
import Action from '../_Action';

export default class RequestResourceSuccessByName extends Action {
  /** The action namespace */
  static namespace = 'Core/Resource';

  static type = 'Core/Resource/RequestResourceSuccessByName';

  static identifier = 'name';

  resourceId: number;
  name: string;
  request: AxiosResponse | ResourceGroupSuccesses<any> | User;

  constructor(name: string, request: AxiosResponse | ResourceGroupSuccesses<any> | User, { resourceId }: { resourceId: number}) {
    super();
    this.type = `${(this.constructor as typeof RequestResourceSuccessByName).type}/${name}`;
    this.name = name;
    this.request = request;
    this.resourceId = resourceId;
  }
}
